import { render, staticRenderFns } from "./TypeIcon.vue?vue&type=template&id=224b11de&"
import script from "./TypeIcon.vue?vue&type=script&lang=ts&"
export * from "./TypeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports